module.exports = __webpack_public_path__ + "static/media/logo.1af34b9e.png";